export async function importDataTable() {
  return await import(
    /* webpackChunkName: "data-table" */ "./site/data-tables/data-table"
  )
}

export async function importMap() {
  return await import(/* webpackChunkName: "map" */ "./site/map")
}
